import { render, staticRenderFns } from "./VirtualServerUsage.vue?vue&type=template&id=ab9bb540&"
import script from "./VirtualServerUsage.vue?vue&type=script&lang=js&"
export * from "./VirtualServerUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports